export const PROMPTBAR_PARTS = [
  'container',
  'textarea',
  'footer',
  'floatRight',
  'submitButton',
] as const;
